import ApiUrls from "../../../../service/api/ApiUrls";
import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import ApiService from "../../../../service/api/ApiService";
import ShowToast from "../../../../widget/common/ui/Toast";
import {
  GroupChatInfoModel,
  GroupConversationInfo,
} from "../../../../model/chats/GroupChatInfoModel";

const GroupChatInfoProvider = new (class GroupChatInfoProvider {
  getGroupInfoAPI = async (
    convId: string
  ): Promise<GroupConversationInfo | null> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);

    const url: string = `${ApiUrls.baseUrl}conversation/get_group_conversation_info`;
    const body: any = {
      account_id: accountId,
      group_conv_id: convId,
    };

    const response: any = await ApiService.postApi(url, body);
    console.log(response);
    if (response != null) {
      if (response["success"] === "1") {
        const groupChatInfoModel: GroupChatInfoModel = response;
        const groupConversationInfo: GroupConversationInfo =
          groupChatInfoModel.result?.group_conversation_info!;

        return groupConversationInfo;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default GroupChatInfoProvider;
